import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useSEO } from "@/hooks/useSEO";
import { Reveal } from "@/components/motion/Reveal";

const MOBILITY_IMG = "/mobility-banner.jpg";

export default function MobilityPage() {
  const { t } = useLanguage();
  useSEO({ title: t.mobility.seo.title, description: t.mobility.seo.description, path: "/mobility" });
  const m = t.mobility;

  return (
    <div data-testid="mobility-page" className="container-site py-14 sm:py-20 lg:py-28">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="eyebrow">{m.eyebrow}</p>
            <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold tracking-tight">{m.title}</h1>
            <p className="mt-5 max-w-2xl text-base sm:text-lg text-muted-foreground leading-relaxed">{m.intro}</p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-10 rounded-xl border border-border bg-card p-6 sm:p-8">
              <h2 className="font-display text-xl font-bold">{m.bridgeTitle}</h2>
              <p className="mt-3 text-muted-foreground leading-relaxed">{m.bridge}</p>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-6 rounded-xl border border-dashed border-border bg-sand-muted/50 p-6 sm:p-8">
              <h2 className="text-sm font-mono uppercase tracking-[0.18em] font-semibold text-muted-foreground">
                {m.noteTitle}
              </h2>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{m.note}</p>
              <Link
                to="/contact"
                data-testid="mobility-contact-cta"
                className="mt-5 inline-flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-white transition-all duration-200 hover:bg-ochre active:scale-[0.98]"
              >
                {m.cta}
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </Link>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <div className="overflow-hidden rounded-xl border border-border shadow-sm lg:sticky lg:top-28">
              <img
                src={MOBILITY_IMG}
                alt={m.imageAlt}
                className="h-72 sm:h-[28rem] w-full object-cover"
                style={{ objectPosition: "50% 28%" }}
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
